import { useEffect, useRef, useState } from 'react';
import styles from './content-editable.module.css';

interface Props extends React.HTMLProps<HTMLDivElement> {
  value: string | undefined;
  setValue: ((str: string) => void) | undefined;
}
export default function ContentEditable({ value, setValue, ...rest }: Props) {
  const ref = useRef<HTMLDivElement | null>(null);
  const [focused, setFocused] = useState(false);
  const [editable, setEditable] = useState(false);

  useEffect(() => {
    if (value !== undefined && !focused && ref.current && ref.current.innerText !== value) {
      ref.current.innerText = value;
    }
  }, [value, focused]);
  return (
    <div
      {...rest}
      ref={ref}
      className={editable ? styles.contentEditable : undefined}
      contentEditable={editable ? true : undefined}
      suppressContentEditableWarning
      onInput={() => {
        if (ref.current) {
          setValue?.(ref.current.innerText);
        }
      }}
      onPointerEnter={() => setEditable(true)}
      onPointerLeave={() => {
        if (!focused) {
          setEditable(false);
        }
      }}
      onFocus={() => setFocused(true)}
      onBlur={() => {
        setFocused(false);
        setEditable(false);
      }}
    />
  );
}
